import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import africaFlag from "@/assets/africa-flag-new.webp";
import { YouTubeFacade } from "@/components/YouTubeFacade";

export function Leadership() {
  return (
    <section className="bg-primary">
      <div className="container-main">
        <div className="grid lg:grid-cols-2 gap-0 items-stretch">
          {/* Content */}
          <div className="py-10 lg:py-14 lg:pr-12">
            <span className="section-label border-primary-foreground/50 text-primary-foreground">
              About IntelliBPO
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-[42px] font-bold text-primary-foreground mt-4 mb-6 uppercase leading-tight">
              Leadership That<br />Drives Results.
            </h2>
            <p className="text-primary-foreground text-base mb-4">
              At IntelliBPO, every client partnership is supported directly by our executive leadership team. Rather than being passed between layers of account management, our clients benefit from clear communication, faster decision-making, and consistent operational oversight.
            </p>
            <p className="text-primary-foreground text-base mb-8">
              This hands-on approach keeps us closely aligned with our clients' objectives and ensures every engagement is actively managed, continuously supported, and focused on delivering measurable results.
            </p>
            <Link
              to="/our-story"
              className="inline-flex items-center gap-2 text-primary-foreground font-semibold uppercase text-sm tracking-wide group">
              
              Meet Our Team
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>

          {/* YouTube Video */}
          <div className="relative lg:py-8">
            



            
            <div className="relative rounded-2xl overflow-hidden h-full min-h-[350px]">
              <YouTubeFacade
                embedUrl="https://www.youtube.com/embed/7PHZQ-LUSA4"
                title="IntelliBPO Video"
                className="w-full h-full absolute inset-0"
              />
            </div>
          </div>
        </div>
      </div>
    </section>);

}